/* MyBeet - wspolna mechanika sekcji: rozwijanie, liczniki, przeciaganie paskow, countdown. */
(function () {
  'use strict';

  // Jedna obsluga wszystkich rozwijanych elementow (akordeon korzysci, timeline).
  // Delegacja na document, zeby dzialalo tez po podmianie sekcji w edytorze.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mb-toggle]');
    if (!btn) return;
    var item = btn.parentElement;
    var group = btn.getAttribute('data-mb-toggle');
    if (group === 'single') {
      var siblings = item.parentElement.querySelectorAll('.is-open');
      siblings.forEach(function (s) { if (s !== item) s.classList.remove('is-open'); });
    }
    item.classList.toggle('is-open');
  });

  // Liczniki: animujemy dopiero, gdy sekcja wejdzie w viewport.
  function runCounter(el) {
    var target = parseFloat(el.getAttribute('data-mb-count')) || 0;
    var suffix = el.getAttribute('data-mb-suffix') || '';
    var dur = 1400, t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = Math.round(target * eased);
      el.textContent = String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function watchCounters(scope) {
    var els = (scope || document).querySelectorAll('[data-mb-count]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(runCounter); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || en.target.dataset.mbCounted) return;
        en.target.dataset.mbCounted = '1';
        runCounter(en.target);
        io.unobserve(en.target);
      });
    }, { threshold: .4 });
    els.forEach(function (el) { io.observe(el); });
  }

  // Drag mysza dla kazdego poziomego paska (.mb-track). Dotyk ma natywny scroll.
  function makeDraggable(track) {
    if (track.dataset.mbDrag) return;
    track.dataset.mbDrag = '1';
    var down = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; startX = e.clientX; startLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      track.scrollLeft = startLeft - (e.clientX - startX);
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      // Klasy NIE zdejmujemy od razu: scroll-snap wlaczony w tej samej klatce
      // wciaga pasek z powrotem na poprzedni kafelek i wyglada, jakby drag nie dzialal.
      setTimeout(function () { track.classList.remove('is-dragging'); }, 260);
    });
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function wireArrows(scope) {
    (scope || document).querySelectorAll('[data-mb-scroll]').forEach(function (btn) {
      if (btn.dataset.mbWired) return;
      btn.dataset.mbWired = '1';
      btn.addEventListener('click', function () {
        var track = document.getElementById(btn.getAttribute('data-mb-target'));
        if (!track) return;
        var dir = parseInt(btn.getAttribute('data-mb-scroll'), 10);
        var step = track.firstElementChild ? track.firstElementChild.offsetWidth + 14 : 300;
        var max = track.scrollWidth - track.clientWidth;
        var next = track.scrollLeft + dir * step;
        // strzalki zapetlaja sie
        if (next > max + 4) next = 0;
        if (next < -4) next = max;
        track.scrollTo({ left: next, behavior: 'smooth' });
      });
    });
  }

  // Countdown do konca dnia - resetuje sie sam, bez zadnej daty w settingsach.
  function countdowns(scope) {
    var els = (scope || document).querySelectorAll('[data-mb-countdown]');
    if (!els.length) return;
    function tick() {
      var now = new Date();
      var end = new Date(now); end.setHours(23, 59, 59, 999);
      var left = Math.max(0, Math.floor((end - now) / 1000));
      var h = String(Math.floor(left / 3600)).padStart(2, '0');
      var m = String(Math.floor((left % 3600) / 60)).padStart(2, '0');
      var s = String(left % 60).padStart(2, '0');
      els.forEach(function (el) {
        var u = el.querySelectorAll('[data-mb-unit]');
        if (u.length === 3) { u[0].textContent = h; u[1].textContent = m; u[2].textContent = s; }
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.mb-track').forEach(makeDraggable);
    wireArrows(scope);
    watchCounters(scope);
    countdowns(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* Wideo bez dzwieku: startuje samo w kadrze, pauzuje po wyjsciu.
   Zaladowane osobno od reszty, zeby dzialalo tez po podmianie sekcji w edytorze. */
(function () {
  'use strict';
  function wire(scope) {
    var vids = (scope || document).querySelectorAll('[data-mb-video]');
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.muted = true;           // atrybut w HTML nie zawsze wystarcza dla autoplay w iOS
      v.defaultMuted = true;
      v.setAttribute('muted', '');
    });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () { /* przegladarka odmowila autoplay */ });
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: .35 });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wire(document); });
  } else { wire(document); }
  document.addEventListener('shopify:section:load', function (e) { wire(e.target); });
})();

/* Timeline: szyna wypelnia sie proporcjonalnie do scrolla, kroki zapalaja sie,
   gdy ich kropka minie srodek ekranu. Liczone w rAF, zeby nie mielic na scrollu. */
(function () {
  'use strict';
  function setup(root) {
    if (root.dataset.mbTlReady) return;
    root.dataset.mbTlReady = '1';
    var fill = root.querySelector('[data-mb-tl-fill]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-mb-tl-step]'));
    var rail = root.querySelector('.mb-tl__rail');
    if (!fill || !steps.length || !rail) return;
    var ticking = false;

    function update() {
      ticking = false;
      var r = rail.getBoundingClientRect();
      var mid = window.innerHeight * 0.55;
      var p = (mid - r.top) / r.height;
      p = Math.max(0, Math.min(1, p));
      fill.style.height = (p * 100).toFixed(2) + '%';
      steps.forEach(function (st) {
        var dot = st.querySelector('.mb-tl__dot');
        var d = dot.getBoundingClientRect();
        st.classList.toggle('is-active', d.top + d.height / 2 <= mid);
      });
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }
  function boot(scope) {
    (scope || document).querySelectorAll('[data-mb-timeline]').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else { boot(document); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* Lista recenzji: trzy widoczne, reszta po kliknieciu. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-mb-revmore]');
  if (!btn) return;
  var list = btn.closest('section').querySelector('[data-mb-revlist]');
  if (!list) return;
  var collapsed = list.classList.toggle('is-collapsed');
  btn.textContent = collapsed ? btn.dataset.more : btn.dataset.less;
  if (collapsed) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
